// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_Id = require("rescript/lib/js/belt_Id.js");
var MM_parser = require("./MM_parser.bs.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_SetInt = require("rescript/lib/js/belt_SetInt.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Belt_HashMapInt = require("rescript/lib/js/belt_HashMapInt.js");
var Belt_HashSetInt = require("rescript/lib/js/belt_HashSetInt.js");
var MM_parenCounter = require("./MM_parenCounter.bs.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");
var Belt_HashSetString = require("rescript/lib/js/belt_HashSetString.js");
var Expln_utils_common = require("@expln/utils/src/main/Expln_utils_common.bs.js");
var MM_progress_tracker = require("../utils/MM_progress_tracker.bs.js");
var Belt_MutableMapString = require("rescript/lib/js/belt_MutableMapString.js");

function mutableMapIntForEachI(map, func) {
  var i = {
    contents: 0
  };
  Belt_HashMapInt.forEach(map, (function (k, v) {
          Curry._3(func, k, v, i.contents);
          i.contents = i.contents + 1 | 0;
        }));
}

function mutableSetIntForEachI(set, func) {
  var i = {
    contents: 0
  };
  Belt_HashSetInt.forEach(set, (function (e) {
          Curry._2(func, e, i.contents);
          i.contents = i.contents + 1 | 0;
        }));
}

function mutableSetIntMakeFromArray(arr) {
  var set = Belt_HashSetInt.make(16);
  arr.forEach(function (v) {
        Belt_HashSetInt.add(set, v);
      });
  return set;
}

function mutableSetIntToArray(set) {
  var arr = new Array(Belt_HashSetInt.size(set));
  var i = {
    contents: 0
  };
  Belt_HashSetInt.forEach(set, (function (e) {
          Caml_array.set(arr, i.contents, e);
          i.contents = i.contents + 1 | 0;
        }));
  return arr;
}

function disjAddPair(disjMap, n, m) {
  if (n === m) {
    return ;
  }
  var min = n <= m ? n : m;
  var max = n <= m ? m : n;
  var set = Belt_HashMapInt.get(disjMap, min);
  if (set !== undefined) {
    return Belt_HashSetInt.add(Caml_option.valFromOption(set), max);
  } else {
    return Belt_HashMapInt.set(disjMap, min, mutableSetIntMakeFromArray([max]));
  }
}

function exprEq(a, b) {
  var len1 = a.length;
  var len2 = b.length;
  if (len1 !== len2) {
    return false;
  }
  var eq = true;
  var i = 0;
  while(eq && i < len1) {
    eq = Caml_array.get(a, i) === Caml_array.get(b, i);
    i = i + 1 | 0;
  };
  return eq;
}

function cmp(e1, e2) {
  var len1 = e1.length;
  var len2 = e2.length;
  var r = Expln_utils_common.intCmp(len1, len2);
  if (r !== 0) {
    return r;
  }
  var res = 0;
  var i = 0;
  while(i < len1 && res === 0) {
    res = Expln_utils_common.intCmp(Caml_array.get(e1, i), Caml_array.get(e2, i));
    i = i + 1 | 0;
  };
  return res;
}

var ExprCmp = Belt_Id.MakeComparable({
      cmp: cmp
    });

var hash = (expr => {
            let hash = 0;
            for (let i = 0; i < expr.length; i++) {
                hash = ( ( hash << 5 ) - hash ) + expr[i];
                hash = hash & hash;  // Convert to 32-bit integer
            }
            return hash;
        });

var ExprHash = Belt_Id.MakeHashable({
      hash: hash,
      eq: exprEq
    });

function forEachCtxInDeclarationOrder(ctx, consumer) {
  var parent = ctx.parent;
  if (parent === undefined) {
    return Curry._1(consumer, ctx);
  }
  var res = forEachCtxInDeclarationOrder(parent, consumer);
  if (res !== undefined) {
    return Caml_option.some(Caml_option.valFromOption(res));
  } else {
    return Curry._1(consumer, ctx);
  }
}

function forEachCtxInReverseOrder(_ctx, consumer) {
  while(true) {
    var ctx = _ctx;
    var res = Curry._1(consumer, ctx);
    if (res !== undefined) {
      return Caml_option.some(Caml_option.valFromOption(res));
    }
    var parent = ctx.parent;
    if (parent === undefined) {
      return ;
    }
    _ctx = parent;
    continue ;
  };
}

function isDebug(ctx) {
  return ctx.contents.debug;
}

function isConstPriv(ctx, sym) {
  return Belt_Option.getWithDefault(Belt_Option.map(Belt_HashMapString.get(Belt_Option.getExn(ctx.root).symToInt, sym), (function (i) {
                    return i < 0;
                  })), false);
}

function isConst(ctx, sym) {
  return isConstPriv(ctx.contents, sym);
}

function isVarPriv(ctx, sym) {
  return Belt_Option.getWithDefault(Belt_Option.map(forEachCtxInReverseOrder(ctx, (function (ctx) {
                        return Belt_HashMapString.get(ctx.symToInt, sym);
                      })), (function (i) {
                    return 0 <= i;
                  })), false);
}

function isVar(ctx, sym) {
  return isVarPriv(ctx.contents, sym);
}

function isHyp(ctx, label) {
  var ctx$1 = ctx.contents;
  return Belt_Option.isSome(forEachCtxInReverseOrder(ctx$1, (function (ctx) {
                    return Belt_HashMapString.get(ctx.symToHyp, label);
                  })));
}

function isAsrt(ctx, label) {
  var ctx$1 = ctx.contents;
  return Belt_Option.isSome(forEachCtxInReverseOrder(ctx$1, (function (ctx) {
                    return Belt_HashMapString.get(ctx.frames, label);
                  })));
}

function disjContains(disj, n, m) {
  var min = n <= m ? n : m;
  var max = n <= m ? m : n;
  var ms = Belt_HashMapInt.get(disj, min);
  if (ms !== undefined) {
    return Belt_HashSetInt.has(Caml_option.valFromOption(ms), max);
  } else {
    return false;
  }
}

var disjNumOfGroups = Belt_HashMapInt.size;

function disjForEach(disjMutable, consumer) {
  Belt_HashMapInt.forEach(disjMutable, (function (n, ms) {
          Belt_HashSetInt.forEach(ms, (function (m) {
                  Curry._2(consumer, n, m);
                }));
        }));
}

function disjToArr(disj) {
  var res = [];
  Belt_MapInt.forEach(disj, (function (n, ms) {
          Belt_SetInt.forEach(ms, (function (m) {
                  res.push([
                        n,
                        m
                      ]);
                }));
        }));
  return res;
}

function disjForEachArr(disjMutable, consumer) {
  disjForEach(disjMutable, (function (n, m) {
          Curry._1(consumer, [
                n,
                m
              ]);
        }));
}

function disjIsEmpty(disjMutable) {
  return Belt_HashMapInt.size(disjMutable) === 0;
}

function isDisj(ctx, n, m) {
  return Belt_Option.getWithDefault(forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
                    if (disjContains(ctx.disj, n, m)) {
                      return true;
                    }
                    
                  })), false);
}

function getHypothesisPriv(ctx, label) {
  return forEachCtxInReverseOrder(ctx, (function (ctx) {
                return Belt_HashMapString.get(ctx.symToHyp, label);
              }));
}

function getHypothesis(ctx, sym) {
  return getHypothesisPriv(ctx.contents, sym);
}

function getFramePriv(ctx, label) {
  return forEachCtxInReverseOrder(ctx, (function (ctx) {
                return Belt_HashMapString.get(ctx.frames, label);
              }));
}

function getFrame(ctx, label) {
  return getFramePriv(ctx.contents, label);
}

function getLocalVars(ctx) {
  return ctx.contents.vars.slice();
}

function getLocalHyps(ctx) {
  return ctx.contents.hyps.slice();
}

function getNumOfVars(ctx) {
  return ctx.contents.varsBaseIdx + ctx.contents.vars.length | 0;
}

function forEachHypothesisInDeclarationOrderPriv(ctx, consumer) {
  return forEachCtxInDeclarationOrder(ctx, (function (ctx) {
                return Expln_utils_common.arrForEach(ctx.hyps, consumer);
              }));
}

function forEachHypothesisInDeclarationOrder(ctx, consumer) {
  return forEachHypothesisInDeclarationOrderPriv(ctx.contents, consumer);
}

function ctxSymToIntPriv(ctx, sym) {
  return forEachCtxInReverseOrder(ctx, (function (ctx) {
                return Belt_HashMapString.get(ctx.symToInt, sym);
              }));
}

function ctxSymToIntExnPriv(ctx, sym) {
  var i = ctxSymToIntPriv(ctx, sym);
  if (i !== undefined) {
    return i;
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "The symbol '" + sym + "' is not declared."
        },
        Error: new Error()
      };
}

function ctxSymsToIntsExnPriv(ctx, symbols) {
  return symbols.map(function (param) {
              return ctxSymToIntExnPriv(ctx, param);
            });
}

function ctxSymsToIntsExn(ctx, symbols) {
  return ctxSymsToIntsExnPriv(ctx.contents, symbols);
}

function ctxStrToIntsExn(ctx, str) {
  return ctxSymsToIntsExnPriv(ctx.contents, MM_parser.getSpaceSeparatedValuesAsArray(str));
}

function ctxSymToInt(ctx, sym) {
  return ctxSymToIntPriv(ctx.contents, sym);
}

function ctxSymToIntExn(ctx, sym) {
  return ctxSymToIntExnPriv(ctx.contents, sym);
}

function ctxIntToSymPriv(ctx, i) {
  if (i < 0) {
    return Belt_Array.get(Belt_Option.getExn(ctx.root).consts, -i | 0);
  } else {
    return forEachCtxInReverseOrder(ctx, (function (ctx) {
                  if (i < ctx.varsBaseIdx) {
                    return ;
                  } else {
                    return Caml_array.get(ctx.vars, i - ctx.varsBaseIdx | 0);
                  }
                }));
  }
}

function ctxIntToSymExnPriv(ctx, i) {
  var str = ctxIntToSymPriv(ctx, i);
  if (str !== undefined) {
    return str;
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot convert " + String(i) + " to a symbol."
        },
        Error: new Error()
      };
}

function ctxIntToSymExn(ctx, i) {
  return ctxIntToSymExnPriv(ctx.contents, i);
}

function ctxIntsToSymsExn(ctx, expr) {
  return expr.map(function (__x) {
              return ctxIntToSymExn(ctx, __x);
            });
}

function ctxIntToSym(ctx, i) {
  return ctxIntToSymPriv(ctx.contents, i);
}

function ctxIntsToStrExn(ctx, expr) {
  var ctx$1 = ctx.contents;
  return expr.map(function (__x) {
                return ctxIntToSymExnPriv(ctx$1, __x);
              }).join(" ");
}

function frmIntToSymExnPriv(ctx, frameVarToSymb, i) {
  if (i < 0) {
    return ctxIntToSymExnPriv(ctx, i);
  } else {
    return Caml_array.get(frameVarToSymb, i);
  }
}

function frmIntToSymExn(ctx, frame, i) {
  return frmIntToSymExnPriv(ctx.contents, frame.frameVarToSymb, i);
}

function frmIntsToStrExnPriv(ctx, frameVarToSymb, expr) {
  return expr.map(function (__x) {
                return frmIntToSymExnPriv(ctx, frameVarToSymb, __x);
              }).join(" ");
}

function frmIntsToStrExn(ctx, frame, expr) {
  return frmIntsToStrExnPriv(ctx.contents, frame.frameVarToSymb, expr);
}

function getTypeOfVarPriv(ctx, varInt) {
  return forEachHypothesisInDeclarationOrderPriv(ctx, (function (hyp) {
                if (hyp.typ === /* F */0 && Caml_array.get(hyp.expr, 1) === varInt) {
                  return Caml_array.get(hyp.expr, 0);
                }
                
              }));
}

function getTypeOfVar(ctx, varInt) {
  return getTypeOfVarPriv(ctx.contents, varInt);
}

function getTypeOfVarExn(ctx, varInt) {
  var typ = getTypeOfVar(ctx, varInt);
  if (typ !== undefined) {
    return typ;
  }
  var sym = ctxIntToSym(ctx, varInt);
  var varName = sym !== undefined ? "'" + sym + "'" : String(varInt);
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot determine type of the variable " + varName + ""
        },
        Error: new Error()
      };
}

function extractMandatoryVariables(ctx, asrt, skipHypsOpt, param) {
  var skipHyps = skipHypsOpt !== undefined ? skipHypsOpt : false;
  var res = Belt_HashSetInt.make(16);
  if (!skipHyps) {
    forEachHypothesisInDeclarationOrderPriv(ctx, (function (hyp) {
            if (hyp.typ === /* E */1) {
              hyp.expr.forEach(function (i) {
                    if (i >= 0) {
                      return Belt_HashSetInt.add(res, i);
                    }
                    
                  });
            }
            
          }));
  }
  asrt.forEach(function (i) {
        if (i >= 0) {
          return Belt_HashSetInt.add(res, i);
        }
        
      });
  return res;
}

function extractMandatoryDisj(ctx, mandatoryVars) {
  var mandatoryDisj = Belt_HashMapInt.make(16);
  forEachCtxInReverseOrder(ctx, (function (ctx) {
          Belt_HashMapInt.forEach(ctx.disj, (function (n, ms) {
                  if (Belt_HashSetInt.has(mandatoryVars, n)) {
                    return Belt_HashSetInt.forEach(ms, (function (m) {
                                  if (Belt_HashSetInt.has(mandatoryVars, m)) {
                                    return disjAddPair(mandatoryDisj, n, m);
                                  }
                                  
                                }));
                  }
                  
                }));
        }));
  return mandatoryDisj;
}

function extractMandatoryHypotheses(ctx, mandatoryVars, skipHypsOpt, param) {
  var skipHyps = skipHypsOpt !== undefined ? skipHypsOpt : false;
  var res = [];
  forEachCtxInDeclarationOrder(ctx, (function (ctx) {
          ctx.hyps.forEach(function (hyp) {
                if (hyp.typ === /* E */1 && !skipHyps || hyp.typ === /* F */0 && Belt_HashSetInt.has(mandatoryVars, Caml_array.get(hyp.expr, 1))) {
                  res.push(hyp);
                  return ;
                }
                
              });
        }));
  return res;
}

function getMandHyps(ctx, expr) {
  var ctx$1 = ctx.contents;
  var mandatoryVars = extractMandatoryVariables(ctx$1, expr, undefined, undefined);
  return extractMandatoryHypotheses(ctx$1, mandatoryVars, undefined, undefined);
}

function getAllHyps(ctx) {
  var hyps = [];
  forEachHypothesisInDeclarationOrder(ctx, (function (hyp) {
          hyps.push(hyp);
        }));
  return Belt_MapString.fromArray(hyps.map(function (hyp) {
                  return [
                          hyp.label,
                          hyp
                        ];
                }));
}

function getAllFrames(ctx) {
  var frames = [];
  forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
          Belt_HashMapString.forEach(ctx.frames, (function (k, v) {
                  frames.push([
                        k,
                        v
                      ]);
                }));
        }));
  return Belt_MapString.fromArray(frames);
}

function forEachFramePriv(ctx, consumer) {
  return forEachCtxInDeclarationOrder(ctx, (function (ctx) {
                var result = {
                  contents: undefined
                };
                Belt_HashMapString.forEach(ctx.frames, (function (param, frm) {
                        if (Belt_Option.isNone(result.contents)) {
                          result.contents = Curry._1(consumer, frm);
                          return ;
                        }
                        
                      }));
                return result.contents;
              }));
}

function forEachFrame(ctx, consumer) {
  return forEachFramePriv(ctx.contents, consumer);
}

function getNestingLevelPriv(ctx) {
  var pCtx = ctx.parent;
  if (pCtx !== undefined) {
    return 1 + getNestingLevelPriv(pCtx) | 0;
  } else {
    return 0;
  }
}

function getNestingLevel(ctx) {
  return getNestingLevelPriv(ctx.contents);
}

function findParentheses(ctx, onProgress, param) {
  var ctx$1 = ctx.contents;
  var getAllExprs = function (ctx) {
    var allExpr = [];
    forEachFramePriv(ctx, (function (frame) {
            frame.hyps.forEach(function (hyp) {
                  if (hyp.typ === /* E */1) {
                    allExpr.push(hyp.expr);
                    return ;
                  }
                  
                });
            allExpr.push(frame.asrt);
          }));
    return allExpr;
  };
  var checkValidParens = function (allExprs, openSym, closeSym) {
    var res = true;
    var openUsed = false;
    var closeUsed = false;
    var parenCnt = MM_parenCounter.parenCntMake([
          openSym,
          closeSym
        ], false, undefined);
    var parenState = /* Balanced */0;
    var allExprsLen = allExprs.length;
    var e = 0;
    while(e < allExprsLen && res) {
      var expr = Caml_array.get(allExprs, e);
      var exprLen = expr.length;
      var s = 0;
      while(s < exprLen && res) {
        var sym = Caml_array.get(expr, s);
        if (!openUsed && sym === openSym) {
          openUsed = true;
        }
        if (!closeUsed && sym === closeSym) {
          closeUsed = true;
        }
        parenState = MM_parenCounter.parenCntPut(parenCnt, sym);
        res = parenState !== /* Failed */2;
        s = s + 1 | 0;
      };
      res = parenState === /* Balanced */0;
      e = e + 1 | 0;
    };
    if (res && openUsed) {
      return closeUsed;
    } else {
      return false;
    }
  };
  var allExprs = getAllExprs(ctx$1);
  var allConsts = ctxSymsToIntsExnPriv(ctx$1, MM_parser.getSpaceSeparatedValuesAsArray("( ) [ ] { } [. ]. [_ ]_ <. >. <\" \"> << >> [s ]s (. ). (( ))").filter(function (param) {
              return isConstPriv(ctx$1, param);
            })).concat(Belt_Array.range(1, Belt_Option.getExn(ctx$1.root).consts.length - 1 | 0).map(function (i) {
            return -i | 0;
          }));
  var maxC = allConsts.length - 2 | 0;
  var progressState = MM_progress_tracker.progressTrackerMutableMake(0.01, undefined, onProgress, undefined, undefined);
  var foundParens = [];
  for(var c = 0; c <= maxC; ++c){
    var openParen = Caml_array.get(allConsts, c);
    var closeParen = Caml_array.get(allConsts, c + 1 | 0);
    if (!foundParens.includes(openParen) && !foundParens.includes(closeParen) && checkValidParens(allExprs, openParen, closeParen)) {
      foundParens.push(openParen);
      foundParens.push(closeParen);
    }
    MM_progress_tracker.progressTrackerMutableSetCurrPct(progressState, c / maxC);
  }
  return foundParens;
}

function disjMutableMake(param) {
  return Belt_HashMapInt.make(16);
}

function getAllDisj(ctx) {
  var disj = Belt_HashMapInt.make(16);
  forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
          Belt_HashMapInt.forEach(ctx.disj, (function (n, ms) {
                  Belt_HashSetInt.forEach(ms, (function (m) {
                          disjAddPair(disj, n, m);
                        }));
                }));
        }));
  return disj;
}

function getLocalDisj(ctx) {
  var disj = Belt_HashMapInt.make(16);
  Belt_HashMapInt.forEach(ctx.contents.disj, (function (n, ms) {
          Belt_HashSetInt.forEach(ms, (function (m) {
                  disjAddPair(disj, n, m);
                }));
        }));
  return disj;
}

function createContext(parent, debugOpt, param) {
  var debug = debugOpt !== undefined ? debugOpt : false;
  var pCtxContentsOpt = parent !== undefined ? parent.contents : undefined;
  var ctx = {
    contents: {
      root: undefined,
      parent: pCtxContentsOpt,
      consts: pCtxContentsOpt !== undefined ? [] : [""],
      varsBaseIdx: pCtxContentsOpt !== undefined ? pCtxContentsOpt.varsBaseIdx + pCtxContentsOpt.vars.length | 0 : 0,
      vars: [],
      symToInt: Belt_HashMapString.make(16),
      disj: Belt_HashMapInt.make(16),
      hyps: [],
      symToHyp: Belt_HashMapString.make(16),
      lastComment: "",
      frames: Belt_HashMapString.make(16),
      frameDescr: Belt_HashMapString.make(16),
      debug: Belt_Option.getWithDefault(Belt_Option.map(pCtxContentsOpt, (function (pCtx) {
                  return pCtx.debug;
                })), debug)
    }
  };
  if (pCtxContentsOpt !== undefined) {
    ctx.contents.root = pCtxContentsOpt.root;
  } else {
    ctx.contents.root = ctx.contents;
  }
  return ctx;
}

function openChildContext(ctx) {
  ctx.contents = createContext(ctx, undefined, undefined).contents;
}

function resetToParentContext(ctx) {
  var parent = ctx.contents.parent;
  var tmp;
  if (parent !== undefined) {
    tmp = parent;
  } else {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "Cannot reset the root context."
          },
          Error: new Error()
        };
  }
  ctx.contents = tmp;
}

function closeChildContext(ctx) {
  var parent = ctx.contents.parent;
  var tmp;
  if (parent !== undefined) {
    Belt_HashMapString.forEach(ctx.contents.frames, (function (k, v) {
            Belt_HashMapString.set(parent.frames, k, v);
          }));
    Belt_HashMapString.forEach(ctx.contents.frameDescr, (function (k, v) {
            Belt_HashMapString.set(parent.frameDescr, k, v);
          }));
    tmp = parent;
  } else {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "Cannot close the root context."
          },
          Error: new Error()
        };
  }
  ctx.contents = tmp;
}

function addDisjPair(ctx, n, m) {
  disjAddPair(ctx.disj, n, m);
}

function renumberVarsInDisj(disj, renumbering) {
  var disjArr = new Array(Belt_HashMapInt.size(disj));
  mutableMapIntForEachI(disj, (function (n, ms, ni) {
          var msArr = new Array(Belt_HashSetInt.size(ms));
          mutableSetIntForEachI(ms, (function (m, mi) {
                  var fv = Belt_MapInt.get(renumbering, m);
                  var tmp;
                  if (fv !== undefined) {
                    tmp = fv;
                  } else {
                    throw {
                          RE_EXN_ID: MM_parser.MmException,
                          _1: {
                            msg: "[1] Cannot determine frame variable for the context variable " + String(m) + ""
                          },
                          Error: new Error()
                        };
                  }
                  Caml_array.set(msArr, mi, tmp);
                }));
          var fv = Belt_MapInt.get(renumbering, n);
          var tmp;
          if (fv !== undefined) {
            tmp = fv;
          } else {
            throw {
                  RE_EXN_ID: MM_parser.MmException,
                  _1: {
                    msg: "[2] Cannot determine frame variable for the context variable " + String(n) + ""
                  },
                  Error: new Error()
                };
          }
          Caml_array.set(disjArr, ni, [
                tmp,
                Belt_SetInt.fromArray(msArr)
              ]);
        }));
  return Belt_MapInt.fromArray(disjArr);
}

function renumberVarsInExpr(expr, renumbering) {
  return expr.map(function (i) {
              if (i < 0) {
                return i;
              } else {
                return Belt_MapInt.getExn(renumbering, i);
              }
            });
}

function createFrameVarToSymbMap(ctx, mandatoryHypotheses, asrt, renumbering) {
  var allVars = Belt_HashSetInt.make(16);
  mandatoryHypotheses.forEach(function (hyp) {
        hyp.expr.forEach(function (i) {
              if (i >= 0) {
                return Belt_HashSetInt.add(allVars, i);
              }
              
            });
      });
  asrt.forEach(function (i) {
        if (i >= 0) {
          return Belt_HashSetInt.add(allVars, i);
        }
        
      });
  var frameVarToSymb = new Array(Belt_HashSetInt.size(allVars));
  Belt_HashSetInt.forEach(allVars, (function (ctxVar) {
          Caml_array.set(frameVarToSymb, Belt_MapInt.getExn(renumbering, ctxVar), ctxIntToSymExnPriv(ctx, ctxVar));
        }));
  return frameVarToSymb;
}

function extractVarTypes(mandatoryHypotheses, renumbering) {
  var varTypes = new Array(Belt_MapInt.size(renumbering));
  mandatoryHypotheses.forEach(function (hyp) {
        if (hyp.typ === /* F */0) {
          return Caml_array.set(varTypes, Belt_MapInt.getExn(renumbering, Caml_array.get(hyp.expr, 1)), Caml_array.get(hyp.expr, 0));
        }
        
      });
  return varTypes;
}

function createFramePriv(ctx, label, exprStr, skipHypsOpt, skipFirstSymCheckOpt, param) {
  var skipHyps = skipHypsOpt !== undefined ? skipHypsOpt : false;
  var skipFirstSymCheck = skipFirstSymCheckOpt !== undefined ? skipFirstSymCheckOpt : false;
  if (label.trim() === "") {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "Cannot use empty string as a label."
          },
          Error: new Error()
        };
  }
  if (Belt_Option.isSome(getHypothesisPriv(ctx, label)) || Belt_Option.isSome(getFramePriv(ctx, label))) {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "Cannot reuse the label '" + label + "'"
          },
          Error: new Error()
        };
  }
  if (exprStr.length < 1) {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "Length of an assertion expression must be at least 1."
          },
          Error: new Error()
        };
  }
  if (!skipFirstSymCheck && !isConstPriv(ctx, Caml_array.get(exprStr, 0))) {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "The first symbol in an assertion expression must be a constant."
          },
          Error: new Error()
        };
  }
  var sym = exprStr.find(function (sym) {
        return Belt_Option.isNone(ctxSymToIntPriv(ctx, sym));
      });
  if (sym !== undefined) {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "The symbol '" + sym + "' must be either a constant or a variable."
          },
          Error: new Error()
        };
  }
  var asrt = exprStr.map(function (__x) {
        return ctxSymToIntExnPriv(ctx, __x);
      });
  var mandatoryVars = extractMandatoryVariables(ctx, asrt, skipHyps, undefined);
  var mandatoryDisj = extractMandatoryDisj(ctx, mandatoryVars);
  var mandatoryHypotheses = extractMandatoryHypotheses(ctx, mandatoryVars, skipHyps, undefined);
  var varRenumbering = Belt_MapInt.fromArray(mutableSetIntToArray(mandatoryVars).map(function (cv, fv) {
            return [
                    cv,
                    fv
                  ];
          }));
  var varTypes = extractVarTypes(mandatoryHypotheses, varRenumbering);
  var hyps = mandatoryHypotheses.map(function (__x) {
        return {
                typ: __x.typ,
                label: __x.label,
                expr: renumberVarsInExpr(__x.expr, varRenumbering)
              };
      });
  var disj = renumberVarsInDisj(mandatoryDisj, varRenumbering);
  var frameVarToSymb = createFrameVarToSymbMap(ctx, mandatoryHypotheses, asrt, varRenumbering);
  var asrt$1 = renumberVarsInExpr(asrt, varRenumbering);
  var dbg = ctx.debug ? ({
        disj: disjToArr(disj).map(function (__x) {
              return frmIntsToStrExnPriv(ctx, frameVarToSymb, __x);
            }),
        hyps: hyps.map(function (hyp) {
              return frmIntsToStrExnPriv(ctx, frameVarToSymb, hyp.expr);
            }),
        asrt: frmIntsToStrExnPriv(ctx, frameVarToSymb, asrt$1)
      }) : undefined;
  var frame_numOfVars = varTypes.length;
  var frame_numOfArgs = hyps.length;
  var frame = {
    disj: disj,
    hyps: hyps,
    asrt: asrt$1,
    label: label,
    frameVarToSymb: frameVarToSymb,
    varTypes: varTypes,
    numOfVars: frame_numOfVars,
    numOfArgs: frame_numOfArgs,
    dbg: dbg
  };
  return [
          frame,
          ctx.lastComment
        ];
}

function createFrame(ctx, label, exprStr, skipHypsOpt, skipFirstSymCheckOpt, param) {
  var skipHyps = skipHypsOpt !== undefined ? skipHypsOpt : false;
  var skipFirstSymCheck = skipFirstSymCheckOpt !== undefined ? skipFirstSymCheckOpt : false;
  return createFramePriv(ctx.contents, label, exprStr, skipHyps, skipFirstSymCheck, undefined);
}

function ctxRemoveFrameDescriptions(ctx) {
  forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
          Belt_HashMapString.clear(ctx.frameDescr);
        }));
}

function applySingleStmt(ctx, stmt) {
  switch (stmt.TAG | 0) {
    case /* Comment */0 :
        ctx.contents.lastComment = stmt.text;
        return ;
    case /* Const */1 :
        stmt.symbols.forEach(function (__x) {
              var ctx$1 = ctx.contents;
              if (Belt_Option.isSome(ctx$1.parent)) {
                throw {
                      RE_EXN_ID: MM_parser.MmException,
                      _1: {
                        msg: "An attempt to declare a constant '" + __x + "' in an inner block."
                      },
                      Error: new Error()
                    };
              }
              if (isConstPriv(ctx$1, __x) || isVarPriv(ctx$1, __x)) {
                throw {
                      RE_EXN_ID: MM_parser.MmException,
                      _1: {
                        msg: "An attempt to re-declare the math symbol '" + __x + "' as a constant."
                      },
                      Error: new Error()
                    };
              }
              Belt_HashMapString.set(ctx$1.symToInt, __x, -ctx$1.consts.length | 0);
              ctx$1.consts.push(__x);
            });
        return ;
    case /* Block */2 :
        throw {
              RE_EXN_ID: MM_parser.MmException,
              _1: {
                msg: "Block statements are not accepted by applySingleStmt()."
              },
              Error: new Error()
            };
    case /* Var */3 :
        stmt.symbols.forEach(function (__x) {
              var ctx$1 = ctx.contents;
              if (isConstPriv(ctx$1, __x) || isVarPriv(ctx$1, __x)) {
                throw {
                      RE_EXN_ID: MM_parser.MmException,
                      _1: {
                        msg: "An attempt to re-declare the math symbol '" + __x + "' as a variable."
                      },
                      Error: new Error()
                    };
              }
              Belt_HashMapString.set(ctx$1.symToInt, __x, ctx$1.varsBaseIdx + ctx$1.vars.length | 0);
              ctx$1.vars.push(__x);
            });
        return ;
    case /* Disj */4 :
        var vars = stmt.vars;
        var ctx$1 = ctx.contents;
        var sym = vars.find(function (sym) {
              return !isVarPriv(ctx$1, sym);
            });
        if (sym !== undefined) {
          throw {
                RE_EXN_ID: MM_parser.MmException,
                _1: {
                  msg: "The symbol '" + sym + "' is not a variable but it is used in a disjoint statement."
                },
                Error: new Error()
              };
        }
        var varInts = vars.map(function (param) {
              return ctxSymToIntExnPriv(ctx$1, param);
            });
        var maxIdx = varInts.length - 1 | 0;
        for(var i = 0; i <= maxIdx; ++i){
          for(var j = i + 1 | 0; j <= maxIdx; ++j){
            addDisjPair(ctx$1, Caml_array.get(varInts, i), Caml_array.get(varInts, j));
          }
        }
        return ;
    case /* Floating */5 :
        var label = stmt.label;
        var exprStr = stmt.expr;
        var ctx$2 = ctx.contents;
        if (exprStr.length !== 2) {
          throw {
                RE_EXN_ID: MM_parser.MmException,
                _1: {
                  msg: "Length of a floating expression must be 2."
                },
                Error: new Error()
              };
        }
        if (!isConstPriv(ctx$2, Caml_array.get(exprStr, 0))) {
          throw {
                RE_EXN_ID: MM_parser.MmException,
                _1: {
                  msg: "The first symbol in a floating expression must be a constant."
                },
                Error: new Error()
              };
        }
        if (!isVarPriv(ctx$2, Caml_array.get(exprStr, 1))) {
          throw {
                RE_EXN_ID: MM_parser.MmException,
                _1: {
                  msg: "The second symbol in a floating expression must be a variable."
                },
                Error: new Error()
              };
        }
        if (Belt_Option.isSome(getHypothesisPriv(ctx$2, label)) || Belt_Option.isSome(getFramePriv(ctx$2, label))) {
          throw {
                RE_EXN_ID: MM_parser.MmException,
                _1: {
                  msg: "Cannot reuse the label '" + label + "'"
                },
                Error: new Error()
              };
        }
        var varName = Caml_array.get(exprStr, 1);
        var varInt = ctxSymToIntExnPriv(ctx$2, varName);
        if (Belt_Option.isSome(getTypeOfVarPriv(ctx$2, varInt))) {
          throw {
                RE_EXN_ID: MM_parser.MmException,
                _1: {
                  msg: "Cannot redefine typecode for the variable '" + varName + "'"
                },
                Error: new Error()
              };
        }
        var expr = ctxSymsToIntsExnPriv(ctx$2, exprStr);
        var hyp = {
          typ: /* F */0,
          label: label,
          expr: expr
        };
        ctx$2.hyps.push(hyp);
        return Belt_HashMapString.set(ctx$2.symToHyp, label, hyp);
    case /* Essential */6 :
        var label$1 = stmt.label;
        var exprStr$1 = stmt.expr;
        var ctx$3 = ctx.contents;
        if (exprStr$1.length < 1) {
          throw {
                RE_EXN_ID: MM_parser.MmException,
                _1: {
                  msg: "Length of an essential expression must be at least 1."
                },
                Error: new Error()
              };
        }
        if (!isConstPriv(ctx$3, Caml_array.get(exprStr$1, 0))) {
          throw {
                RE_EXN_ID: MM_parser.MmException,
                _1: {
                  msg: "The first symbol in an essential expression must be a constant."
                },
                Error: new Error()
              };
        }
        var expr$1 = ctxSymsToIntsExnPriv(ctx$3, exprStr$1);
        var hyp$1 = {
          typ: /* E */1,
          label: label$1,
          expr: expr$1
        };
        ctx$3.hyps.push(hyp$1);
        return Belt_HashMapString.set(ctx$3.symToHyp, label$1, hyp$1);
    case /* Axiom */7 :
    case /* Provable */8 :
        var label$2 = stmt.label;
        var exprStr$2 = stmt.expr;
        var ctx$4 = ctx.contents;
        var match = createFramePriv(ctx$4, label$2, exprStr$2, undefined, undefined, undefined);
        Belt_HashMapString.set(ctx$4.frames, label$2, match[0]);
        return Belt_HashMapString.set(ctx$4.frameDescr, label$2, match[1]);
    
  }
}

function loadContext(ast, initialContext, stopBeforeOpt, stopAfterOpt, expectedNumOfAssertionsOpt, onProgressOpt, debugOpt, param) {
  var stopBefore = stopBeforeOpt !== undefined ? stopBeforeOpt : "";
  var stopAfter = stopAfterOpt !== undefined ? stopAfterOpt : "";
  var expectedNumOfAssertions = expectedNumOfAssertionsOpt !== undefined ? expectedNumOfAssertionsOpt : -1;
  var onProgress = onProgressOpt !== undefined ? onProgressOpt : (function (param) {
        
      });
  var debug = debugOpt !== undefined ? debugOpt : false;
  var assertionsProcessed = {
    contents: 0
  };
  var progressTracker = MM_progress_tracker.progressTrackerMutableMake(0.01, undefined, onProgress, undefined, undefined);
  var onAsrtProcess = function (param) {
    if (expectedNumOfAssertions > 0) {
      assertionsProcessed.contents = assertionsProcessed.contents + 1;
      return MM_progress_tracker.progressTrackerMutableSetCurrPct(progressTracker, assertionsProcessed.contents / expectedNumOfAssertions);
    }
    
  };
  return MM_parser.traverseAst(initialContext !== undefined ? initialContext : createContext(undefined, debug, undefined), ast, (function (ctx, node) {
                  var match = node.stmt;
                  switch (match.TAG | 0) {
                    case /* Block */2 :
                        if (match.level > 0) {
                          openChildContext(ctx);
                        }
                        return ;
                    case /* Axiom */7 :
                    case /* Provable */8 :
                        break;
                    default:
                      return ;
                  }
                  onAsrtProcess(undefined);
                  if (stopBefore === match.label) {
                    return Caml_option.some(undefined);
                  }
                  
                }), (function (ctx, node) {
                  var stmt = node.stmt;
                  if (stmt.TAG !== /* Block */2) {
                    applySingleStmt(ctx, stmt);
                  }
                  
                }), (function (ctx, node) {
                  var match = node.stmt;
                  switch (match.TAG | 0) {
                    case /* Block */2 :
                        if (match.level > 0) {
                          closeChildContext(ctx);
                        }
                        return ;
                    case /* Axiom */7 :
                    case /* Provable */8 :
                        break;
                    default:
                      return ;
                  }
                  if (stopAfter === match.label) {
                    return Caml_option.some(undefined);
                  }
                  
                }), undefined)[0];
}

function generateNewVarNames(ctx, types, typeToPrefix, usedNames, param) {
  var prefixToCnt = Belt_MutableMapString.make(undefined);
  var incCnt = function (prefix) {
    Belt_MutableMapString.set(prefixToCnt, prefix, Belt_MutableMapString.getWithDefault(prefixToCnt, prefix, 0) + 1 | 0);
  };
  var maxI = types.length - 1 | 0;
  var res = [];
  for(var i = 0; i <= maxI; ++i){
    var typeStr = ctxIntToSymExn(ctx, Caml_array.get(types, i));
    var prefix = Belt_MapString.getWithDefault(typeToPrefix, typeStr, typeStr);
    incCnt(prefix);
    var newName = {
      contents: prefix + String(Belt_MutableMapString.getWithDefault(prefixToCnt, prefix, 0))
    };
    while(isConst(ctx, newName.contents) || isVar(ctx, newName.contents) || Belt_Option.getWithDefault(Belt_Option.map(usedNames, (function(newName){
              return function (__x) {
                return Belt_HashSetString.has(__x, newName.contents);
              }
              }(newName))), false)) {
      incCnt(prefix);
      newName.contents = prefix + String(Belt_MutableMapString.getWithDefault(prefixToCnt, prefix, 0));
    };
    res.push(newName.contents);
  }
  return res;
}

function generateNewLabels(ctx, prefix, amount, usedLabels, param) {
  var maxI = amount - 1 | 0;
  var cnt = 0;
  var res = [];
  for(var _for = 0; _for <= maxI; ++_for){
    cnt = cnt + 1 | 0;
    var newName = {
      contents: prefix + String(cnt)
    };
    while(isHyp(ctx, newName.contents) || isAsrt(ctx, newName.contents) || Belt_Option.getWithDefault(Belt_Option.map(usedLabels, (function(newName){
              return function (__x) {
                return Belt_HashSetString.has(__x, newName.contents);
              }
              }(newName))), false)) {
      cnt = cnt + 1 | 0;
      newName.contents = prefix + String(cnt);
    };
    res.push(newName.contents);
  }
  return res;
}

function renumberConstsInExpr(expr, constRenum) {
  var maxI = expr.length - 1 | 0;
  for(var i = 0; i <= maxI; ++i){
    var sym = Caml_array.get(expr, i);
    if (sym < 0) {
      Caml_array.set(expr, i, Belt_Option.getWithDefault(Belt_HashMapInt.get(constRenum, sym), sym));
    }
    
  }
}

function moveConstsToBegin(ctx, constsStr) {
  var rootCtx = Belt_Option.getExn(ctx.contents.root);
  var constsToMove = Belt_HashSetInt.fromArray(MM_parser.getSpaceSeparatedValuesAsArray(constsStr).map(function (__x) {
                return ctxSymToInt(ctx, __x);
              }).filter(function (intOpt) {
              return Belt_Option.mapWithDefault(intOpt, false, (function (i) {
                            return i < 0;
                          }));
            }).map(Belt_Option.getExn));
  var constsLen = Belt_HashSetInt.size(constsToMove);
  var reservedIdxs = Belt_HashSetInt.make(constsLen);
  var getConstToMoveFar = function (param) {
    var res = 1;
    while(Belt_HashSetInt.has(reservedIdxs, res) || Belt_HashSetInt.has(constsToMove, -res | 0)) {
      res = res + 1 | 0;
    };
    Belt_HashSetInt.add(reservedIdxs, res);
    return -res | 0;
  };
  var constRenum = Belt_HashMapInt.make(constsLen);
  Belt_HashSetInt.forEach(constsToMove, (function (constToMoveClose) {
          if (constToMoveClose >= (-constsLen | 0)) {
            return ;
          }
          var constToMoveFar = getConstToMoveFar(undefined);
          Belt_HashMapInt.set(constRenum, constToMoveClose, constToMoveFar);
          Belt_HashMapInt.set(constRenum, constToMoveFar, constToMoveClose);
          var symTmp = Caml_array.get(rootCtx.consts, -constToMoveClose | 0);
          Caml_array.set(rootCtx.consts, -constToMoveClose | 0, Caml_array.get(rootCtx.consts, -constToMoveFar | 0));
          Caml_array.set(rootCtx.consts, -constToMoveFar | 0, symTmp);
          Belt_HashMapString.set(rootCtx.symToInt, Caml_array.get(rootCtx.consts, -constToMoveClose | 0), constToMoveClose);
          Belt_HashMapString.set(rootCtx.symToInt, Caml_array.get(rootCtx.consts, -constToMoveFar | 0), constToMoveFar);
        }));
  forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
          ctx.hyps.forEach(function (hyp) {
                renumberConstsInExpr(hyp.expr, constRenum);
              });
          Belt_HashMapString.forEach(ctx.frames, (function (param, frame) {
                  frame.hyps.forEach(function (hyp) {
                        renumberConstsInExpr(hyp.expr, constRenum);
                      });
                  renumberConstsInExpr(frame.asrt, constRenum);
                  renumberConstsInExpr(frame.varTypes, constRenum);
                }));
        }));
}

exports.createContext = createContext;
exports.applySingleStmt = applySingleStmt;
exports.openChildContext = openChildContext;
exports.closeChildContext = closeChildContext;
exports.resetToParentContext = resetToParentContext;
exports.loadContext = loadContext;
exports.isDebug = isDebug;
exports.isConst = isConst;
exports.isVar = isVar;
exports.isHyp = isHyp;
exports.isAsrt = isAsrt;
exports.isDisj = isDisj;
exports.getHypothesis = getHypothesis;
exports.getMandHyps = getMandHyps;
exports.getAllHyps = getAllHyps;
exports.getAllFrames = getAllFrames;
exports.getAllDisj = getAllDisj;
exports.getLocalDisj = getLocalDisj;
exports.getFrame = getFrame;
exports.getLocalVars = getLocalVars;
exports.getLocalHyps = getLocalHyps;
exports.getNumOfVars = getNumOfVars;
exports.forEachFrame = forEachFrame;
exports.forEachHypothesisInDeclarationOrder = forEachHypothesisInDeclarationOrder;
exports.getNestingLevel = getNestingLevel;
exports.findParentheses = findParentheses;
exports.getTypeOfVar = getTypeOfVar;
exports.getTypeOfVarExn = getTypeOfVarExn;
exports.ctxSymToInt = ctxSymToInt;
exports.ctxIntToSym = ctxIntToSym;
exports.ctxSymToIntExn = ctxSymToIntExn;
exports.ctxSymsToIntsExn = ctxSymsToIntsExn;
exports.ctxStrToIntsExn = ctxStrToIntsExn;
exports.ctxIntToSymExn = ctxIntToSymExn;
exports.ctxIntsToSymsExn = ctxIntsToSymsExn;
exports.ctxIntsToStrExn = ctxIntsToStrExn;
exports.frmIntToSymExn = frmIntToSymExn;
exports.frmIntsToStrExn = frmIntsToStrExn;
exports.createFrame = createFrame;
exports.ctxRemoveFrameDescriptions = ctxRemoveFrameDescriptions;
exports.moveConstsToBegin = moveConstsToBegin;
exports.generateNewVarNames = generateNewVarNames;
exports.generateNewLabels = generateNewLabels;
exports.disjMutableMake = disjMutableMake;
exports.disjAddPair = disjAddPair;
exports.disjContains = disjContains;
exports.disjNumOfGroups = disjNumOfGroups;
exports.disjForEachArr = disjForEachArr;
exports.disjForEach = disjForEach;
exports.disjIsEmpty = disjIsEmpty;
exports.exprEq = exprEq;
exports.ExprCmp = ExprCmp;
exports.ExprHash = ExprHash;
/* ExprCmp Not a pure module */
